import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { QIInput, QIButton } from "../../../components";
import { useForgotPasswordMutation } from "../service";
import { forgetPasswordSchema } from "../validations";
import { ConfirmationModal } from "../Shared/ConfirmationModal";
import sprite from "../../../assets/icons.svg";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    email: "",
  });

  const [errorModal, setShowErrorModal] = useState({
    msg: "",
    show: false,
    type: "",
  });

  const formik = useFormik({
    initialValues,
    validationSchema: forgetPasswordSchema,
    onSubmit: (values) => handleForgetPassword(values),
  });

  const [create, { isSuccess, isError, error }] = useForgotPasswordMutation();

  const handleForgetPassword = (formData) => {
    create(formData);
  };

  useEffect(() => {
    if (isSuccess) {
      setShowErrorModal({
        msg: "We have sent you reset link. Please check your mail",
        show: true,
        type: "success",
        headerText: "Reset Email Success!",
      });
    }
    if (isError) {
      setShowErrorModal({
        msg: error?.data?.message ? error?.data?.message : "There is no account with given e-mail",
        show: true,
        type: "warning",
        headerText: "Reset Email Alert!",
      });
    }
  }, [isSuccess, isError]);

  const closeWarningModal = () => {
    if (errorModal.type === "success") {
      navigate("/");
    }
    setShowErrorModal({
      msg: "",
      show: false,
      type: "",
    });
  };

  return (
    <div className="login-layout">
      <header className="qi-header">
        <h3 className="qi-header_title text-center">
          <strong>Fleet Mobility Data Platform</strong>
        </h3>
      </header>
      <div className="login-form-container">
        <QIInput
          label="Email"
          type="text"
          {...formik.getFieldProps("email")}
          error={formik.touched.email && formik.errors.email}
        />

        <QIButton
          className="primary w-full mt-4"
          icon={{ src: `${sprite}#next`, className: "next-icon" }}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Send
        </QIButton>

        <div className="text-center mt-10">
          <a href="/login">Back to login</a>
        </div>
      </div>
      {errorModal.show && (
        <ConfirmationModal
          onOkay={() => {
            closeWarningModal();
          }}
          show={errorModal.show}
          headerText={errorModal.headerText}
        >
          <p className="text-center mt-10">
            <>
              <span className={`${errorModal.type === "warning" ? "configurations-error" : ""}`}>
                {errorModal.msg} : <strong>{formik.values.email}</strong>
              </span>
            </>
          </p>
        </ConfirmationModal>
      )}

      <footer className="qi-footer text-center">
        <p className="">
          Copyright &copy;
          {new Date().getFullYear()} Fleet Management. All rights reserved.
        </p>
      </footer>
    </div>
  );
};
